import React from "react";
import SingleImage from "../Gallaryprops";

//2019
import Img191 from "../../../atrimages/pervious event images atri/2019/1.jpg";
import Img192 from "../../../atrimages/pervious event images atri/2019/2.jpg";
import Img193 from "../../../atrimages/pervious event images atri/2019/3.jpg";
import Img194 from "../../../atrimages/pervious event images atri/2019/4.jpg";
import Img195 from "../../../atrimages/pervious event images atri/2019/5.jpg";
import Img196 from "../../../atrimages/pervious event images atri/2019/6.jpg";
import Img197 from "../../../atrimages/pervious event images atri/2019/7.jpg";
import Img198 from "../../../atrimages/pervious event images atri/2019/8.jpg";
import Img199 from "../../../atrimages/pervious event images atri/2019/9.jpg";
import Img1910 from "../../../atrimages/pervious event images atri/2019/10.jpg";
import Img1911 from "../../../atrimages/pervious event images atri/2019/1.jpg";
import Img1912 from "../../../atrimages/pervious event images atri/2019/11.jpg";
import Img1913 from "../../../atrimages/pervious event images atri/2019/12.jpg";
import Img1914 from "../../../atrimages/pervious event images atri/2019/13.jpg";
import Img1915 from "../../../atrimages/pervious event images atri/2019/14.jpg";
import Img1916 from "../../../atrimages/pervious event images atri/2019/15.jpg";
import Img1917 from "../../../atrimages/pervious event images atri/2019/16.jpg";
import Img1918 from "../../../atrimages/pervious event images atri/2019/17.jpg";
import Img1919 from "../../../atrimages/pervious event images atri/2019/18.jpg";
import Img1920 from "../../../atrimages/pervious event images atri/2019/19.jpg";
import Img1921 from "../../../atrimages/pervious event images atri/2019/20.jpg";

export default function borealis19() {
  return (
    <div className="YearWise">
      <div className="2019">
        <h2>GLIMPSE OF BOREALIS - 2019</h2>
        <SingleImage gimage={Img191} title="President" />
        <SingleImage gimage={Img192} title="President" />
        <SingleImage gimage={Img193} title="President" />
        <SingleImage gimage={Img194} title="President" />
        <SingleImage gimage={Img195} title="President" />
        <SingleImage gimage={Img196} title="President" />
        <SingleImage gimage={Img197} title="President" />
        <SingleImage gimage={Img198} title="President" />
        <SingleImage gimage={Img199} title="President" />
        <SingleImage gimage={Img1910} title="President" />
        <SingleImage gimage={Img1911} title="President" />
        <SingleImage gimage={Img1912} title="President" />
        <SingleImage gimage={Img1913} title="President" />
        <SingleImage gimage={Img1914} title="President" />
        <SingleImage gimage={Img1915} title="President" />
        <SingleImage gimage={Img1916} title="President" />
        <SingleImage gimage={Img1917} title="President" />
        <SingleImage gimage={Img1918} title="President" />
        <SingleImage gimage={Img1919} title="President" />
        <SingleImage gimage={Img1920} title="President" />
        <SingleImage gimage={Img1921} title="President" />
      </div>
      <br />
      <br />
    </div>
  );
}
